export default __webpack_public_path__ + "static/media/hht2_ep_20.6bd6e827.png";